import { useQuery } from '@tanstack/react-query';

import getProductUpdates from '../api/getProductUpdates';

const useProductUpdates = (id: number, product_id: string) => {
  const query = useQuery({
    queryKey: ['product-updates', id, product_id],
    queryFn: async () => {
      const response = await getProductUpdates(id, product_id);

      return response.data;
    },
    enabled: !!id && !!product_id,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    staleTime: 0
  });

  return query;
};

export default useProductUpdates;
